let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5vvv9"), load("6qah4"), load("aZinD"), load("8hTWF"), load("410C5"), load("h3G8d")]).then(() => parcelRequire('cul1e'));